<template>
  <g font-family="sans-serif">
    <!-- fibers -->
    <rect
      :width="(svgWidth - svgPadding - spreaderPadding) - (svgWidth / 2)"
      :height="fiberHeight"
      :x="svgPadding + spreaderPadding"
      :y="(svgHeight / 2)"
      style="fill: gold; stroke-width: 1; stroke: rgb(223,168,39);"
    />
    <rect
      :width="(svgWidth - svgPadding - spreaderPadding) - (svgWidth / 2)"
      :height="fiberHeight"
      :x="(svgWidth / 2)"
      :y="(svgHeight / 2)"
      style="fill: gold; stroke-width: 1; stroke: rgb(223,168,39);"
      v-if="!isPigtail"
    />

    <g>
      <!-- fibers -->
      <g>
        <g class="fibers-side-a-label">
          <text
            class="fibers-side-a-desc-fibers"
            :x="svgPadding"
            :y="svgHeight / 2 - (['12', '8'].includes(fiberCount) && plugSideACount === 1 ? 60 : 0)"
            font-size=".75em"
            dy="-.25em"
            fill="rgb(143, 143, 143)"
          >
            <tspan fill="orange">{{ fiberCount }} </tspan>
            <tspan>{{ $t('total-fibers') }}</tspan>
          </text>
          <text
            class="fibers-side-a-desc-plugcount"
            :x="svgPadding"
            :y="svgHeight / 2 - (['12', '8'].includes(fiberCount) && plugSideACount === 1 ? 60 : 0)"
            font-size=".75em"
            dy="1em"
            fill="rgb(143, 143, 143)"
            v-if="plugSideACount"
          >
            <tspan fill="orange">{{ plugSideACount }} </tspan>
            <tspan>{{ $t('total-plugs-side-a', [shortenedPlexSideA]) }}</tspan>
          </text>
        </g>
        <g class="fibers-side-a" v-if="plugSideACount !== 1">
          <g class="fibers-side-a-upper-not-dx"
            v-if="(!plugSideACount && plexSideA !== 'dx') || (plexSideA !== 'dx' && plugSideACount !== 1)">
            <g v-if="!plugSideACount || plugSideACount >= 3">
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2"
                :y1="svgHeight / 2"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
              <line
                :x1="svgPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2"
                :y1="svgPadding * 2"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
            </g>

            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap"
              :y1="svgHeight / 2"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
            <line
              :x1="svgPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap"
              :y1="svgPadding * 2 + fiberGap"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
          </g>

          <g class="fibers-side-a-upper-dx"
            v-else>
            <g class="fibers-side-a-multi"
              v-if="plugSideACount >= 4 || (fiberCount >= 8 && plexSideA === 'dx')">
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2 - 5"
                :y1="svgHeight / 2"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2 + 5"
                :y1="svgHeight / 2"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
              <line
                :x1="svgPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2 -5"
                :y1="svgPadding * 2 -5"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
              <line
                :x1="svgPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2 + 5"
                :y1="svgPadding * 2 + 5"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
            </g>

            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap - 5"
              :y1="svgHeight / 2"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap + 5"
              :y1="svgHeight / 2"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
            <line
              :x1="svgPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap - 5"
              :y1="svgPadding * 2 + fiberGap -5"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
            <line
              :x1="svgPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap + 5"
              :y1="svgPadding * 2 + fiberGap + 5"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
          </g>



          <g class="fibers-side-a-lower-not-dx"
            v-if="(!plugSideACount && plexSideA !== 'dx') || (plexSideA !== 'dx' && plugSideACount !== 1)">
            <g v-if="!plugSideACount || plugSideACount >= 4">
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - svgPadding * 2"
                :y1="svgHeight / 2"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
              <line
                :x1="svgPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - svgPadding * 2"
                :y1="svgHeight - svgPadding * 2"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
            </g>

            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - svgPadding * 2 - fiberGap"
              :y1="svgHeight / 2"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
            <line
              :x1="svgPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - svgPadding * 2 - fiberGap"
              :y1="svgHeight - svgPadding * 2 - fiberGap"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
          </g>

          <g class="fibers-side-a-lower-dx"
            v-else>
            <g v-if="plugSideACount >= 4 || (fiberCount >= 8 && plexSideA === 'dx')">
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - (svgPadding * 2 - 5)"
                :y1="svgHeight / 2"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - (svgPadding * 2 + 5)"
                :y1="svgHeight / 2"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
              <line
                :x1="svgPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - (svgPadding * 2 -5)"
                :y1="svgHeight - (svgPadding * 2 -5)"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
              <line
                :x1="svgPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - (svgPadding * 2 + 5)"
                :y1="svgHeight - (svgPadding * 2 + 5)"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
            </g>

            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - (svgPadding * 2 + fiberGap - 5)"
              :y1="svgHeight / 2"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - (svgPadding * 2 + fiberGap + 5)"
              :y1="svgHeight / 2"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
            <line
              :x1="svgPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - (svgPadding * 2 + fiberGap - 5)"
              :y1="svgHeight - (svgPadding * 2 + fiberGap -5)"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
            <line
              :x1="svgPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - (svgPadding * 2 + fiberGap + 5)"
              :y1="svgHeight - (svgPadding * 2 + fiberGap + 5)"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
          </g>
        </g>

        <g class="fibers-side-b-label" v-if="!isPigtail">
          <text
            :x="svgWidth - svgPadding"
            text-anchor="end"
            :y="svgHeight / 2 - (['12', '8'].includes(fiberCount) && plugSideBCount === 1 ? 60 : 0)"
            font-size=".75em"
            dy="-.25em"
            fill="rgb(143, 143, 143)"
          >
            <tspan fill="orange">{{ fiberCount }} </tspan>
            <tspan>{{ $t('total-fibers') }}</tspan>
          </text>
          <text
            v-if="plugSideBCount"
            :x="svgWidth - svgPadding"
            text-anchor="end"
            :y="svgHeight / 2 - (['12', '8'].includes(fiberCount) && plugSideBCount === 1 ? 60 : 0)"
            font-size=".75em"
            dy="1em"
            fill="rgb(143, 143, 143)"
          >
            <tspan fill="orange">{{ plugSideBCount }} </tspan>
            <tspan>{{ $t('total-plugs-side-b', [shortenedPlexSideB]) }}</tspan>
          </text>
        </g>
        <g class="fibers-side-b-label" v-if="isPigtail">
          <text
            :x="svgWidth - svgPadding"
            text-anchor="end"
            :y="svgHeight / 2 - 20"
            font-size=".75em"
            fill="rgb(143, 143, 143)"
          >
            <tspan fill="orange">{{ fiberCount }} </tspan>
            <tspan>{{ $t('total-fibers') }} {{ $t('open')}}</tspan>
          </text>
        </g>
        <g class="fibers-side-b" v-if="!isPigtail && plugSideBCount !== 1">
          <g v-if="(!plugSideBCount && plexSideB !== 'dx') || (plexSideB !== 'dx' && plugSideBCount !== 1)"
            class="fibers-side-b-upper-not-dx">
            <g v-if="!plugSideBCount || plugSideBCount >= 3">
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2"
                :y1="svgHeight / 2"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
              <line
                :x1="svgWidth - (svgPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2"
                :y1="svgPadding * 2"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
            </g>

            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap"
              :y1="svgHeight / 2"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
            <line
              :x1="svgWidth - (svgPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap"
              :y1="svgPadding * 2 + fiberGap"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
          </g>

          <g v-else
            class="fibers-side-b-upper-dx">
            <g v-if="plugSideBCount >= 4 || (fiberCount >= 8 && plexSideB === 'dx')">
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2 - 5"
                :y1="svgHeight / 2"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2 + 5"
                :y1="svgHeight / 2"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
              <line
                :x1="svgWidth - (svgPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2 - 5"
                :y1="svgPadding * 2 - 5"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
              <line
                :x1="svgWidth - (svgPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2 + 5"
                :y1="svgPadding * 2 + 5"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
            </g>

            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap - 5"
              :y1="svgHeight / 2"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap + 5"
              :y1="svgHeight / 2"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
            <line
              :x1="svgWidth - (svgPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap - 5"
              :y1="svgPadding * 2 + fiberGap - 5"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
            <line
              :x1="svgWidth - (svgPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap + 5"
              :y1="svgPadding * 2 + fiberGap + 5"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
          </g>
          <g v-if="(!plugSideBCount && plexSideB !== 'dx') || (plexSideB !== 'dx' && plugSideBCount !== 1)"
            class="fibers-side-b-lower-not-dx">
            <g v-if="!plugSideBCount || plugSideBCount >= 4">
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2"
                :y1="svgHeight / 2"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
              <line
                :x1="svgWidth - (svgPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2"
                :y1="svgHeight - svgPadding * 2"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
            </g>

            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap"
              :y1="svgHeight / 2"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
            <line
              :x1="svgWidth - (svgPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap"
              :y1="svgHeight - svgPadding * 2 - fiberGap"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
          </g>

          <g v-else
            class="fibers-side-b-lower-dx">
            <g v-if="plugSideBCount >= 4 || (fiberCount >= 8 && plexSideB === 'dx')">
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2 - 5"
                :y1="svgHeight / 2"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2 + 5"
                :y1="svgHeight / 2"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
              <line
                :x1="svgWidth - (svgPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2 - 5"
                :y1="svgHeight - svgPadding * 2 - 5"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
              <line
                :x1="svgWidth - (svgPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2 + 5"
                :y1="svgHeight - svgPadding * 2 + 5"
                stroke-width="2"
                stroke="rgb(223,168,39)"
              />
            </g>

            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap - 5"
              :y1="svgHeight / 2"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap + 5"
              :y1="svgHeight / 2"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
            <line
              :x1="svgWidth - (svgPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap - 5"
              :y1="svgHeight - svgPadding * 2 - fiberGap - 5"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
            <line
              :x1="svgWidth - (svgPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap + 5"
              :y1="svgHeight - svgPadding * 2 - fiberGap + 5"
              stroke-width="2"
              stroke="rgb(223,168,39)"
            />
          </g>
        </g>
      </g>

      <!-- cladding -->
      <g>
        <g class="cladding-side-a" v-if="plugSideACount !== 1">
          <g v-if="(!plugSideACount && plexSideA !== 'dx') || plexSideA !== 'dx'">
            <g v-if="!plugSideACount || plugSideACount >= 3">
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2"
                :y1="svgHeight / 2"
                stroke-width="4"
                stroke="#ccbe82"
              />
              <line
                :x1="svgPadding + svgCladdingMargin"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2"
                :y1="svgPadding * 2"
                stroke-width="4"
                stroke="#ccbe82"
              />
            </g>

            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap"
              :y1="svgHeight / 2"
              stroke-width="4"
              stroke="#ccbe82"
            />
            <line
              :x1="svgPadding + svgCladdingMargin"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap"
              :y1="svgPadding * 2 + fiberGap"
              stroke-width="4"
              stroke="#ccbe82"
            />

            <g v-if="!plugSideACount || plugSideACount >= 4">
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - svgPadding * 2"
                :y1="svgHeight / 2"
                stroke-width="4"
                stroke="#ccbe82"
              />
              <line
                :x1="svgPadding + svgCladdingMargin"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - svgPadding * 2"
                :y1="svgHeight - svgPadding * 2"
                stroke-width="4"
                stroke="#ccbe82"
              />
            </g>

            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - svgPadding * 2 - fiberGap"
              :y1="svgHeight / 2"
              stroke-width="4"
              stroke="#ccbe82"
            />
            <line
              :x1="svgPadding + svgCladdingMargin"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - svgPadding * 2 - fiberGap"
              :y1="svgHeight - svgPadding * 2 - fiberGap"
              stroke-width="4"
              stroke="#ccbe82"
            />
          </g>


          <g v-else>
            <g v-if="plugSideACount >= 4 || (fiberCount >= 8 && plexSideA === 'dx')">
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2 - 5"
                :y1="svgHeight / 2"
                stroke-width="4"
                stroke="#ccbe82"
              />
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2 + 5"
                :y1="svgHeight / 2"
                stroke-width="4"
                stroke="#ccbe82"
              />
              <line
                :x1="svgPadding + svgCladdingMargin"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2 - 5"
                :y1="svgPadding * 2 - 5"
                stroke-width="4"
                stroke="#ccbe82"
              />
              <line
                :x1="svgPadding + svgCladdingMargin"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2 + 5"
                :y1="svgPadding * 2 + 5"
                stroke-width="4"
                stroke="#ccbe82"
              />
            </g>

            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap - 5"
              :y1="svgHeight / 2"
              stroke-width="4"
              stroke="#ccbe82"
            />
            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap + 5"
              :y1="svgHeight / 2"
              stroke-width="4"
              stroke="#ccbe82"
            />
            <line
              :x1="svgPadding + svgCladdingMargin"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap - 5"
              :y1="svgPadding * 2 + fiberGap - 5"
              stroke-width="4"
              stroke="#ccbe82"
            />
            <line
              :x1="svgPadding + svgCladdingMargin"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap + 5"
              :y1="svgPadding * 2 + fiberGap + 5"
              stroke-width="4"
              stroke="#ccbe82"
            />

            <g v-if="plugSideACount >= 4 || (fiberCount >= 8 && plexSideA === 'dx')">
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - svgPadding * 2 - 5"
                :y1="svgHeight / 2"
                stroke-width="4"
                stroke="#ccbe82"
              />
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - svgPadding * 2 + 5"
                :y1="svgHeight / 2"
                stroke-width="4"
                stroke="#ccbe82"
              />
              <line
                :x1="svgPadding + svgCladdingMargin"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - svgPadding * 2 - 5"
                :y1="svgHeight - svgPadding * 2 - 5"
                stroke-width="4"
                stroke="#ccbe82"
              />
              <line
                :x1="svgPadding + svgCladdingMargin"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - svgPadding * 2 + 5"
                :y1="svgHeight - svgPadding * 2 + 5"
                stroke-width="4"
                stroke="#ccbe82"
              />
            </g>

            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - svgPadding * 2 - fiberGap - 5"
              :y1="svgHeight / 2"
              stroke-width="4"
              stroke="#ccbe82"
            />
            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - svgPadding * 2 - fiberGap + 5"
              :y1="svgHeight / 2"
              stroke-width="4"
              stroke="#ccbe82"
            />
            <line
              :x1="svgPadding + svgCladdingMargin"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - svgPadding * 2 - fiberGap - 5"
              :y1="svgHeight - svgPadding * 2 - fiberGap - 5"
              stroke-width="4"
              stroke="#ccbe82"
            />
            <line
              :x1="svgPadding + svgCladdingMargin"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - svgPadding * 2 - fiberGap + 5"
              :y1="svgHeight - svgPadding * 2 - fiberGap + 5"
              stroke-width="4"
              stroke="#ccbe82"
            />
          </g>
        </g>

        <g class="cladding-side-b" v-if="plugSideBCount !== 1 && !isPigtail">
          <g v-if="(!plugSideBCount && plexSideB !== 'dx') || (plexSideB !== 'dx' && plugSideBCount !== 1) && !isPigtail">
            <g v-if="!plugSideBCount || plugSideBCount >= 3">
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2"
                :y1="svgHeight / 2"
                stroke-width="4"
                stroke="#ccbe82"
              />
              <line
                :x1="svgWidth - (svgPadding + svgCladdingMargin)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2"
                :y1="svgPadding * 2"
                stroke-width="4"
                stroke="#ccbe82"
              />
            </g>

            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap"
              :y1="svgHeight / 2"
              stroke-width="4"
              stroke="#ccbe82"
            />
            <line
              :x1="svgWidth - (svgPadding + svgCladdingMargin)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap"
              :y1="svgPadding * 2 + fiberGap"
              stroke-width="4"
              stroke="#ccbe82"
            />

            <g v-if="!plugSideBCount || plugSideBCount >= 4">
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2"
                :y1="svgHeight / 2"
                stroke-width="4"
                stroke="#ccbe82"
              />
              <line
                :x1="svgWidth - (svgPadding + svgCladdingMargin)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2"
                :y1="svgHeight - svgPadding * 2"
                stroke-width="4"
                stroke="#ccbe82"
              />
            </g>

            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap"
              :y1="svgHeight / 2"
              stroke-width="4"
              stroke="#ccbe82"
            />
            <line
              :x1="svgWidth - (svgPadding + svgCladdingMargin)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap"
              :y1="svgHeight - svgPadding * 2 - fiberGap"
              stroke-width="4"
              stroke="#ccbe82"
            />
          </g>

          <g v-else>
            <g v-if="plugSideBCount >= 4 || (fiberCount >= 8 && plexSideB === 'dx')">
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2 - 5"
                :y1="svgHeight / 2"
                stroke-width="4"
                stroke="#ccbe82"
              />
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2 + 5"
                :y1="svgHeight / 2"
                stroke-width="4"
                stroke="#ccbe82"
              />
              <line
                :x1="svgWidth - (svgPadding + svgCladdingMargin)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2 - 5"
                :y1="svgPadding * 2 - 5"
                stroke-width="4"
                stroke="#ccbe82"
              />
              <line
                :x1="svgWidth - (svgPadding + svgCladdingMargin)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2 + 5"
                :y1="svgPadding * 2 + 5"
                stroke-width="4"
                stroke="#ccbe82"
              />
            </g>

            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap - 5"
              :y1="svgHeight / 2"
              stroke-width="4"
              stroke="#ccbe82"
            />
            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap + 5"
              :y1="svgHeight / 2"
              stroke-width="4"
              stroke="#ccbe82"
            />
            <line
              :x1="svgWidth - (svgPadding + svgCladdingMargin)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap - 5"
              :y1="svgPadding * 2 + fiberGap - 5"
              stroke-width="4"
              stroke="#ccbe82"
            />
            <line
              :x1="svgWidth - (svgPadding + svgCladdingMargin)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap + 5"
              :y1="svgPadding * 2 + fiberGap + 5"
              stroke-width="4"
              stroke="#ccbe82"
            />

            <g v-if="plugSideBCount >= 4 || (fiberCount >= 8 && plexSideB === 'dx')">
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2 - 5"
                :y1="svgHeight / 2"
                stroke-width="4"
                stroke="#ccbe82"
              />
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2 + 5"
                :y1="svgHeight / 2"
                stroke-width="4"
                stroke="#ccbe82"
              />
              <line
                :x1="svgWidth - (svgPadding + svgCladdingMargin)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2 - 5"
                :y1="svgHeight - svgPadding * 2 - 5"
                stroke-width="4"
                stroke="#ccbe82"
              />
              <line
                :x1="svgWidth - (svgPadding + svgCladdingMargin)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2 + 5"
                :y1="svgHeight - svgPadding * 2 + 5"
                stroke-width="4"
                stroke="#ccbe82"
              />
            </g>

            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap - 5"
              :y1="svgHeight / 2"
              stroke-width="4"
              stroke="#ccbe82"
            />
            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap + 5"
              :y1="svgHeight / 2"
              stroke-width="4"
              stroke="#ccbe82"
            />
            <line
              :x1="svgWidth - (svgPadding + svgCladdingMargin)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap - 5"
              :y1="svgHeight - svgPadding * 2 - fiberGap - 5"
              stroke-width="4"
              stroke="#ccbe82"
            />
            <line
              :x1="svgWidth - (svgPadding + svgCladdingMargin)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap + 5"
              :y1="svgHeight - svgPadding * 2 - fiberGap + 5"
              stroke-width="4"
              stroke="#ccbe82"
            />
          </g>
        </g>

        <rect
          :width="(svgWidth / 2) - svgPadding"
          :height="8"
          :x="(svgWidth / 2)"
          :y="(svgHeight / 2 - 8 / 2)"
          fill="#ccbe82"
          v-if="isPigtail"
        />
      </g>

      <!-- whips -->
      <g>
        <g class="whips-side-a" v-if="plugSideACount !== 1">
          <g v-if="(!plugSideACount && plexSideA !== 'dx') || (plexSideA !== 'dx' && plugSideACount !== 1)">
            <g v-if="!plugSideACount || plugSideACount >= 3">
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2"
                :y1="svgHeight / 2"
                stroke-width="4"
                :style="whipStyle"
                stroke-linecap="round"
              />
              <line
                :x1="svgPadding + svgCloakMargin"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2"
                :y1="svgPadding * 2"
                :style="whipStyle"
              />
            </g>

            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap"
              :y1="svgHeight / 2"
              :style="whipStyle"
              stroke-linecap="round"
            />
            <line
              :x1="svgPadding + svgCloakMargin"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap"
              :y1="svgPadding * 2 + fiberGap"
              :style="whipStyle"
            />

            <g v-if="!plugSideACount || plugSideACount >= 4">
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - svgPadding * 2"
                :y1="svgHeight / 2"
                :style="whipStyle"
                stroke-linecap="round"
              />
              <line
                :x1="svgPadding + svgCloakMargin"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - svgPadding * 2"
                :y1="svgHeight - svgPadding * 2"
                :style="whipStyle"
              />
            </g>

            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - svgPadding * 2 - fiberGap"
              :y1="svgHeight / 2"
              :style="whipStyle"
            />
            <line
              :x1="svgPadding + svgCloakMargin"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - svgPadding * 2 - fiberGap"
              :y1="svgHeight - svgPadding * 2 - fiberGap"
              :style="whipStyle"
              stroke-linecap="round"
            />
          </g>

          <g v-else>
            <g v-if="plugSideACount >= 4 || (fiberCount >= 8 && plexSideA === 'dx')">
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2 - 5"
                :y1="svgHeight / 2"
                stroke-width="4"
                :style="whipStyle"
                stroke-linecap="round"
              />
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2 + 5"
                :y1="svgHeight / 2"
                stroke-width="4"
                :style="whipStyle"
                stroke-linecap="round"
              />
              <line
                :x1="svgPadding + svgCloakMargin"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2 - 5"
                :y1="svgPadding * 2 - 5"
                :style="whipStyle"
              />
              <line
                :x1="svgPadding + svgCloakMargin"
                :x2="svgPadding + spreadOffset"
                :y2="svgPadding * 2 + 5"
                :y1="svgPadding * 2 + 5"
                :style="whipStyle"
              />
            </g>

            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap - 5"
              :y1="svgHeight / 2"
              :style="whipStyle"
              stroke-linecap="round"
            />
            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap + 5"
              :y1="svgHeight / 2"
              :style="whipStyle"
              stroke-linecap="round"
            />
            <line
              :x1="svgPadding + svgCloakMargin"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap - 5"
              :y1="svgPadding * 2 + fiberGap - 5"
              :style="whipStyle"
            />
            <line
              :x1="svgPadding + svgCloakMargin"
              :x2="svgPadding + spreadOffset"
              :y2="svgPadding * 2 + fiberGap + 5"
              :y1="svgPadding * 2 + fiberGap + 5"
              :style="whipStyle"
            />

            <g v-if="plugSideACount >= 4 || (fiberCount >= 8 && plexSideA === 'dx')">
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - svgPadding * 2 - 5"
                :y1="svgHeight / 2"
                :style="whipStyle"
                stroke-linecap="round"
              />
              <line
                :x1="svgPadding + spreaderPadding"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - svgPadding * 2 + 5"
                :y1="svgHeight / 2"
                :style="whipStyle"
                stroke-linecap="round"
              />
              <line
                :x1="svgPadding + svgCloakMargin"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - svgPadding * 2 - 5"
                :y1="svgHeight - svgPadding * 2 - 5"
                :style="whipStyle"
              />
              <line
                :x1="svgPadding + svgCloakMargin"
                :x2="svgPadding + spreadOffset"
                :y2="svgHeight - svgPadding * 2 + 5"
                :y1="svgHeight - svgPadding * 2 + 5"
                :style="whipStyle"
              />
            </g>

            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - svgPadding * 2 - fiberGap - 5"
              :y1="svgHeight / 2"
              :style="whipStyle"
            />
            <line
              :x1="svgPadding + spreaderPadding"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - svgPadding * 2 - fiberGap + 5"
              :y1="svgHeight / 2"
              :style="whipStyle"
            />
            <line
              :x1="svgPadding + svgCloakMargin"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - svgPadding * 2 - fiberGap - 5"
              :y1="svgHeight - svgPadding * 2 - fiberGap - 5"
              :style="whipStyle"
              stroke-linecap="round"
            />
            <line
              :x1="svgPadding + svgCloakMargin"
              :x2="svgPadding + spreadOffset"
              :y2="svgHeight - svgPadding * 2 - fiberGap + 5"
              :y1="svgHeight - svgPadding * 2 - fiberGap + 5"
              :style="whipStyle"
              stroke-linecap="round"
            />
          </g>
        </g>

        <g class="whips-side-b" v-if="plugSideBCount !== 1 && !isPigtail">
          <g v-if="(!plugSideBCount && plexSideB !== 'dx') || (plexSideB !== 'dx' && plugSideBCount !== 1)">
            <g v-if="!plugSideBCount || plugSideBCount >= 3">
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2"
                :y1="svgHeight / 2"
                stroke-width="4"
                :style="whipStyle"
                stroke-linecap="round"
              />
              <line
                :x1="svgWidth - (svgPadding + svgCloakMargin)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2"
                :y1="svgPadding * 2"
                :style="whipStyle"
              />
            </g>

            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap"
              :y1="svgHeight / 2"
              :style="whipStyle"
              stroke-linecap="round"
            />
            <line
              :x1="svgWidth - (svgPadding + svgCloakMargin)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap"
              :y1="svgPadding * 2 + fiberGap"
              :style="whipStyle"
            />

            <g v-if="!plugSideBCount || plugSideBCount >= 4">
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2"
                :y1="svgHeight / 2"
                :style="whipStyle"
              />
              <line
                :x1="svgWidth - (svgPadding + svgCloakMargin)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2"
                :y1="svgHeight - svgPadding * 2"
                :style="whipStyle"
                stroke-linecap="round"
              />
            </g>

            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap"
              :y1="svgHeight / 2"
              :style="whipStyle"
            />
            <line
              :x1="svgWidth - (svgPadding + svgCloakMargin)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap"
              :y1="svgHeight - svgPadding * 2 - fiberGap"
              :style="whipStyle"
              stroke-linecap="round"
            />
          </g>

          <g v-else>
            <g v-if="plugSideBCount >= 4 || (fiberCount >= 8 && plexSideB === 'dx')">
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2 - 5"
                :y1="svgHeight / 2"
                stroke-width="4"
                :style="whipStyle"
                stroke-linecap="round"
              />
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2 + 5"
                :y1="svgHeight / 2"
                stroke-width="4"
                :style="whipStyle"
                stroke-linecap="round"
              />
              <line
                :x1="svgWidth - (svgPadding + svgCloakMargin)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2 - 5"
                :y1="svgPadding * 2 - 5"
                :style="whipStyle"
              />
              <line
                :x1="svgWidth - (svgPadding + svgCloakMargin)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgPadding * 2 + 5"
                :y1="svgPadding * 2 + 5"
                :style="whipStyle"
              />
            </g>

            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap - 5"
              :y1="svgHeight / 2"
              :style="whipStyle"
              stroke-linecap="round"
            />
            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap + 5"
              :y1="svgHeight / 2"
              :style="whipStyle"
              stroke-linecap="round"
            />
            <line
              :x1="svgWidth - (svgPadding + svgCloakMargin)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap - 5"
              :y1="svgPadding * 2 + fiberGap - 5"
              :style="whipStyle"
            />
            <line
              :x1="svgWidth - (svgPadding + svgCloakMargin)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgPadding * 2 + fiberGap + 5"
              :y1="svgPadding * 2 + fiberGap + 5"
              :style="whipStyle"
            />

            <g v-if="plugSideBCount >= 4 || (fiberCount >= 8 && plexSideB === 'dx')">
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2 - 5"
                :y1="svgHeight / 2"
                :style="whipStyle"
              />
              <line
                :x1="svgWidth - (svgPadding + spreaderPadding)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2 + 5"
                :y1="svgHeight / 2"
                :style="whipStyle"
              />
              <line
                :x1="svgWidth - (svgPadding + svgCloakMargin)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2 - 5"
                :y1="svgHeight - svgPadding * 2 - 5"
                :style="whipStyle"
                stroke-linecap="round"
              />
              <line
                :x1="svgWidth - (svgPadding + svgCloakMargin)"
                :x2="svgWidth - (svgPadding + spreadOffset)"
                :y2="svgHeight - svgPadding * 2 + 5"
                :y1="svgHeight - svgPadding * 2 + 5"
                :style="whipStyle"
                stroke-linecap="round"
              />
            </g>

            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap - 5"
              :y1="svgHeight / 2"
              :style="whipStyle"
            />
            <line
              :x1="svgWidth - (svgPadding + spreaderPadding)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap + 5"
              :y1="svgHeight / 2"
              :style="whipStyle"
            />
            <line
              :x1="svgWidth - (svgPadding + svgCloakMargin)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap - 5"
              :y1="svgHeight - svgPadding * 2 - fiberGap - 5"
              :style="whipStyle"
              stroke-linecap="round"
            />
            <line
              :x1="svgWidth - (svgPadding + svgCloakMargin)"
              :x2="svgWidth - (svgPadding + spreadOffset)"
              :y2="svgHeight - svgPadding * 2 - fiberGap + 5"
              :y1="svgHeight - svgPadding * 2 - fiberGap + 5"
              :style="whipStyle"
              stroke-linecap="round"
            />
          </g>
        </g>
      </g>
    </g>
    <!-- cloak -->
    <rect
      :width="(svgWidth / 2 - svgPadding)  - 150"
      :height="cloakHeight"
      :x="(svgPadding + spreaderPadding -5)"
      :y="(svgHeight / 2 - cloakHeight / 2)"
      :style="cloakStyle"
    />

    <rect
      :width="(svgWidth - (spreaderPadding - svgPadding)) - (svgWidth / 2) - (svgCloakMargin)"
      :height="cloakHeight"
      :x="(svgWidth / 2)"
      :y="(svgHeight / 2 - cloakHeight / 2)"
      :style="cloakStyle"
      v-if="!isPigtail"
    />

    <rect
      :width="(svgWidth / 2) - (svgPadding + 5)"
      :height="cloakHeight"
      :x="(svgWidth / 2)"
      :y="(svgHeight / 2 - cloakHeight / 2)"
      :style="cloakStyle"
      v-if="isPigtail"
    />

    <!-- reflection -->
    <rect
      :width="(svgWidth / 2) - (svgPadding + spreaderPadding)"
      :height="1"
      :x="(svgPadding + spreaderPadding - 5)"
      :y="(svgHeight / 2 - 2)"
      style="fill: white;"
    />

    <rect
      :width="(svgWidth - svgPadding) - (svgWidth / 2) - svgCladdingMargin - (svgCloakMargin)"
      :height="1"
      :x="(svgWidth / 2)"
      :y="(svgHeight / 2 - 2)"
      style="fill: white;"
      v-if="!isPigtail"
    />

    <rect
      :width="(svgWidth / 2) - (svgPadding)"
      :height="1"
      :x="(svgWidth / 2) - 3"
      :y="(svgHeight / 2 - 2)"
      style="fill: white;"
      v-if="isPigtail"
    />

    <g
      class="spreader spreader-a"
      :transform="`translate(170 ${(svgHeight / 2 ) + 12 * thicknessMultiplier }) rotate(-90) scale(${thicknessMultiplier} ${thicknessMultiplier})`"
    >
      <rect
        v-if="!plugSideACount && $route.name === 'trunk'"
        x="0"
        y="0"
        fill="white"
        width="24"
        height="50"
        stroke="rgb(143, 143, 143)"
        stroke-width="1"
        stroke-dasharray="1 2"
      />
      <g :style="`opacity: ${ !plugSideACount && $route.name === 'trunk' ? .1 : 1 }`">
        <rect 
          x="2" 
          y="15" 
          v-if="needsSpreaderA && $route.name === 'trunk'" 
          height="15" 
          width="20" 
          :fill="$store.state.filters.spreadersA.id 
            ? getCssColor($store.state.spreaders.filter(spreader => spreader.id ===$store.state.filters.spreadersA.id)[0].material) 
            : getCssColor('schwarz')"
        />
        <rect
          class="shrinking-tube" 
          x="4" 
          :y="needsSpreaderA && $route.name === 'trunk' ? 25 : 10" 
          height="25" width="16" 
          :fill="$store.state.filters.spreadersA.id 
            ? getCssColor($store.state.spreaders.filter(spreader => spreader.id ===$store.state.filters.spreadersA.id)[0].material) 
            : getCssColor('schwarz')" 
        />
        <rect 
          :fill="$store.state.filters.spreadersA.id 
            ? getCssColor($store.state.spreaders.filter(spreader => spreader.id ===$store.state.filters.spreadersA.id)[0].material) 
            : getCssColor('schwarz')" 
          x="4"
          class="shrinking-tube" 
          y="0" 
          width="16" 
          height="16" />
        <g :transform="`translate(0 ${needsSpreaderA ? 35 : 30})`" class="fixation-a"
          v-if="$store.state.filters.fixationsA.id">
          <rect fill="white" stroke="#444" stroke-width=".5" x="4" y="0" width="16" height="10" />
          <line x1="4" x2="20" y1="0" y2="0" stroke="lightgrey" stroke-width="1" />
          <line x1="4" x2="20" y1="3" y2="3" stroke="lightgrey" stroke-width="1" />
          <line x1="4" x2="20" y1="6" y2="6" stroke="lightgrey" stroke-width="1" />
          <line x1="4" x2="20" y1="9" y2="9" stroke="lightgrey" stroke-width="1" />
          <rect x="0" y="10" height="5" width="24" fill="darkgrey" />
        </g>
      </g>
    </g>
    <g
      v-if="!isPigtail"
      class="spreader spreader-b"
      :transform="`translate(${svgWidth - 170} ${(svgHeight / 2 ) - 12 * thicknessMultiplier }) rotate(90) scale(${thicknessMultiplier} ${thicknessMultiplier})`"
    >
      <rect
        v-if="!plugSideBCount && $route.name === 'trunk'"
        x="0"
        y="0"
        fill="white"
        width="24"
        height="50"
        stroke="rgb(143, 143, 143)"
        stroke-width="1"
        stroke-dasharray="1 2"
      />
      <g :style="`opacity: ${ !plugSideBCount && $route.name === 'trunk' ? .1 : 1 }`">
        <rect x="2" y="15" v-if="needsSpreaderB && $route.name === 'trunk'" height="15" width="20" :fill="$store.state.filters.spreadersB.id ? getCssColor($store.state.spreaders.filter(spreader => spreader.id ===$store.state.filters.spreadersB.id)[0].material) : getCssColor('schwarz')" />
        <rect x="4" :y="needsSpreaderB && $route.name === 'trunk' ? 25 : 10" height="25" width="16" :fill="$store.state.filters.spreadersB.id ? getCssColor($store.state.spreaders.filter(spreader => spreader.id ===$store.state.filters.spreadersB.id)[0].material) : getCssColor('schwarz')" />
        <rect :fill="$store.state.filters.spreadersB.id ? getCssColor($store.state.spreaders.filter(spreader => spreader.id ===$store.state.filters.spreadersB.id)[0].material) : getCssColor('schwarz')" x="4" y="0" width="16" height="16" />
        <g :transform="`translate(0 ${needsSpreaderB ? 35 : 30})`"
          v-if="$store.state.filters.fixationsB.id">
          <rect fill="white" stroke="#444" stroke-width=".5" x="4" y="0" width="16" height="10" />
          <line x1="4" x2="20" y1="0" y2="0" stroke="lightgrey" stroke-width="1" />
          <line x1="4" x2="20" y1="3" y2="3" stroke="lightgrey" stroke-width="1" />
          <line x1="4" x2="20" y1="6" y2="6" stroke="lightgrey" stroke-width="1" />
          <line x1="4" x2="20" y1="9" y2="9" stroke="lightgrey" stroke-width="1" />
          <rect x="0" y="10" height="5" width="24" fill="darkgrey" />
        </g>
      </g>
    </g>
    <g class="whip-legends">
      <g class="whip-a-legend"
        v-if="$store.getters.selectedValue('whipsA', 'id')">
        <!-- <line
          :x1="svgPadding + svgCladdingMargin"
          :x2="svgPadding + svgCladdingMargin"
          :y1="svgHeight - (23)"
          :y2="svgHeight - (15)"
          stroke="#f59c00"
          stroke-width="1"
        /> -->
        <polygon
          fill="#f59c00"
          :points="`
            ${svgPadding}, ${svgHeight - (15)}
            ${svgPadding + 7}, ${svgHeight - (15 + 3.5)}
            ${svgPadding + 7}, ${svgHeight - (15 - 3.5)}
            `" />
        <line
          :x1="svgPadding"
          :x2="spreaderPadding + 25"
          :y1="svgHeight - (15)"
          :y2="svgHeight - (15)"
          stroke="#f59c00"
          stroke-width="1"
        />
        <polygon
          fill="#f59c00"
          :points="`
            ${spreaderPadding + 25}, ${svgHeight - (15)}
            ${spreaderPadding + 25 - 7}, ${svgHeight - (15 + 3.5)}
            ${spreaderPadding + 25 - 7}, ${svgHeight - (15 - 3.5)}
            `" />
        <line
          :x1="spreaderPadding + 25"
          :x2="spreaderPadding + 25"
          :y1="svgHeight - (23)"
          :y2="svgHeight - (15)"
          stroke="#f59c00"
          stroke-width="1"
        />
        <text
          :x="((spreaderPadding + 25) + (svgPadding)) / 2"
          :y="svgHeight - (15) - 3"
          text-anchor="middle"
          fill="rgb(143, 143, 143)"
          font-size=".75em">{{ $store.state.whips.filter(whip => whip.id === $store.getters.selectedValue('whipsA', 'id'))[0].length }}</text>

      </g>

      <g class="whip-b-legend"
        v-if="$store.getters.selectedValue('whipsB', 'id')"
        :transform="`translate(${svgWidth - spreaderPadding - svgPadding - 25} 0)`">
        <line
          :x1="svgPadding"
          :x2="svgPadding"
          :y1="svgHeight - (23)"
          :y2="svgHeight - (15)"
          stroke="#f59c00"
          stroke-width="1"
        />
        <polygon
          fill="#f59c00"
          :points="`
            ${svgPadding }, ${svgHeight - (15)}
            ${svgPadding + 7}, ${svgHeight - (15 + 3.5)}
            ${svgPadding + 7}, ${svgHeight - (15 - 3.5)}
            `" />
        <line
          :x1="svgPadding"
          :x2="spreaderPadding + 25"
          :y1="svgHeight - (15)"
          :y2="svgHeight - (15)"
          stroke="#f59c00"
          stroke-width="1"
        />
        <text
          :x="((spreaderPadding + 25) + (svgPadding)) / 2"
          :y="svgHeight - (15) - 3"
          text-anchor="middle"
          fill="rgb(143, 143, 143)"
          font-size=".75em">{{ $store.state.whips.filter(whip => whip.id === $store.getters.selectedValue('whipsB', 'id'))[0].length }}</text>

      </g>

    </g>
  </g>
</template>

<script>
import { mapGetters } from "vuex"
import { needsSpreader } from '@/utils/trunk-cable-needs-spreader'

export default {
  data() {
    return {
      fiberHeight: 1,
      claddingHeight: 6,
      cloakHeight: 8,
      spreaderPadding: 160,
      spreadOffset: 80
    };
  },
  props: {
    svgHeight: Number,
    svgWidth: {
      type: Number
    },
    svgPadding: {
      type: Number,
      default: 20
    },
    svgCladdingMargin: {
      type: Number,
      default: 30
    },
    svgCloakMargin: {
      type: Number,
      default: 35
    },
    cableColor: String,
    isPigtail: {
      type: Boolean,
      default: false
    },
    thickness: {
      type: String,
      default: null
    },
    fiberCount: {
      type: String,
      default: ""
    },
    whipColor: {
      type: String,
      default: "default"
    },
    plugSideACount: {
      type: Number,
      default: null
    },
    plugSideBCount: {
      type: Number,
      default: null
    },
    plexSideA: {
      type: String,
      default: null
    },
    plexSideB: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters([
      'getCssColor',
      'selectedValue'
    ]),
    thicknessMultiplier() {
      return this.thickness === "thick"
        ? 1.1
        : this.thickness === "thin"
        ? 0.9
        : 1;
    },

    // cloak color based on cable color selection
    cloakStyle: function() {
      let color = this.getCssColor(this.cableColor);
      return `fill: ${color}; stroke-width: ${
        this.thickness === "thin" ? 3 : this.thickness === "thick" ? 8 : 5
      }; stroke: ${color};`;
    },
    whipStyle() {
      let color = this.getCssColor(this.whipColor);
      return `fill: ${color}; stroke-width: 3.5; stroke: ${color};`;
    },
    shortenedPlexSideA() {
      return this.plexSideA.split(" ")[0].toUpperCase() || "";
    },
    shortenedPlexSideB() {
      return this.plexSideB.split(" ")[0].toUpperCase() || "";
    },
    needsSpreaderA () {
      return needsSpreader({ cableType: this.selectedValue('cables', 'cableType'), plugType: this.selectedValue('plugsA', 'plugType')})
    },
    needsSpreaderB () {
      return needsSpreader({ cableType: this.selectedValue('cables', 'cableType'), plugType: this.selectedValue('plugsB', 'plugType')})
    },
    fiberGap() {
      if (this.$route.name === 'patch-cord') {
        return this.fiberCount === '12' ? 75 : 75;
      }
      return 32;
    },
  },
};
</script>

<style>
</style>